import { TResponsiveValue } from './responsive-classes';

const processGap = (gap: TResponsiveValue<number | string>, styles: Record<string, string>) => {
  if (typeof gap === 'number' && !styles[`gap${ gap }`]) return { gap: `${ gap }px` };
  if (typeof gap === 'string') return { gap };
  return {};
};

const processTemplateColumns = (templateColumns: string | number) => {
  return { gridTemplateColumns: templateColumns };
};

const processTemplateRows = (templateRows: string | number) => {
  return { gridTemplateRows: templateRows };
};

const processColSpan = (colSpan: number | 'full') => {
  if (typeof colSpan === 'number' && colSpan > 12) return { gridColumn: `span ${ colSpan }` };
  if (colSpan === 'full') return { gridColumn: '1 / -1' };
  return {};
};

const processRowSpan = (rowSpan: number | 'full') => {
  if (typeof rowSpan === 'number' && rowSpan > 12) return { gridRow: `span ${ rowSpan }` };
  if (rowSpan === 'full') return { gridRow: '1 / -1' };
  return {};
};

const processColStart = (colStart: number) => {
  if (colStart > 12) return { gridColumnStart: colStart };
  return {};
};

const processRowStart = (rowStart: number) => {
  if (rowStart > 12) return { gridRowStart: rowStart };
  return {};
};

const styleProcessors = {
  gap: processGap,
  templateColumns: processTemplateColumns,
  templateRows: processTemplateRows,
  colSpan: processColSpan,
  rowSpan: processRowSpan,
  colStart: processColStart,
  rowStart: processRowStart,
};

export const processInlineStyles = (
  props: Record<string, TResponsiveValue<any>>,
  styles: Record<string, string>,
): React.CSSProperties => {
  let result: React.CSSProperties = {};

  Object.entries(props).forEach(([prop, value]) => {
    const processor = styleProcessors[prop];
    if (processor && value !== undefined) {
      result = { ...result, ...processor(value, styles) };
    }
  });

  return result;
};
